module.exports = __webpack_public_path__ + "static/media/kw.398bcf75.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kw.svg
// module id = 865
// module chunks = 0